import React from "react";
import "./ActiveUsersData_card.css";
function ActiveUsersData_card() {
  return (
    <>
      <section className="ActiveUsersData_card">
        <div className="row">
          <div className="col-sm-6">
            <div className="heading_holder heading_holder_1" >
              <h2>USA</h2>
            </div>
            <div className="text_holder">
              <h2>535</h2>
              <p>Active Users</p>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="heading_holder heading_holder_2 ">
              <h2>USA</h2>
            </div>
            <div className="text_holder">
              <h2>535</h2>
              <p>Active Users</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ActiveUsersData_card;
